export default "__VITE_ASSET__Kcfk6L7n__ 600w";